import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/pwa/registerServiceWorker";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode is intentionally NOT wrapped here — react-leaflet 4.2.1
// throws "Map container is already initialized" under Strict Mode's dev-only
// double-invoke. Prod builds don't double-invoke effects, so this is dev-only anyway.
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// PWA — Phase 1. Gated behind window.__PWA_ENABLED__ (set by index.html from
// the backend `pwa_enabled` feature flag). Registration is a no-op until then.
registerServiceWorker();
